import _ from 'lodash';
import { E_PermissionHttpMethod as E_HttpMethod } from '@/apis/service/AccountApi.types';
import { E_Troubleshooting, E_ApplyTrial, E_Workspace, E_NavigationLibrary, E_OpenApi, E_OpenPlatform, E_DeveloperTool, E_ProductManager, E_SystemManager, E_SynchronizationRedis, E_SearchEngineManagement, E_SessionManagement, E_CoreUtility, PermissionResourceEdit, E_RecommendationManagement, E_PatsnapLab, E_OperationTool, E_Account, E_Company_Organization, E_Company_Organization_Setting, CapacityDetail, CompanyOrder, CompanyCredits, E_DataProtection, E_IllegalManagement, E_DataAnalysis, EP_Behavior, EP_Admin, EP_ReleasePlan, EP_ActivityPromotion, EP_Notifications, EP_ProductResourceSpaceManagement, EP_GlobalView, EP_DataAnalysis, EP_PqlRuleManagement, } from './permission.types';
class Permission {
    or(...others) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let result = this;
        _.each(others, other => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            result = new PermissionOr(result, other);
        });
        return result;
    }
    and(...others) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let result = this;
        _.each(others, other => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            result = new PermissionAnd(result, other);
        });
        return result;
    }
    /**
     * 类方法
     */
    static Of(option) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new PermissionSingle(option);
    }
    static Or(first, ...rest) {
        return first.or(...rest);
    }
    static And(first, ...rest) {
        return first.and(...rest);
    }
}
class PermissionSingle extends Permission {
    constructor(options) {
        super();
        this.options = options;
    }
    get Open() {
        const { resource, method, check, } = this.options;
        return check(resource, method);
    }
    /**
     * 获取权限详情
     */
    get Description() {
        const { resource, method, } = this.options;
        return `Resource: ${resource}, Method: ${method}, Open: ${this.Open}\n`;
    }
}
class PermissionOr extends Permission {
    constructor(a, b) {
        super();
        this.a = a;
        this.b = b;
    }
    get Open() {
        return this.a.Open || this.b.Open; // this.this.Open ==> false  this.权限字符串.Open
    }
    get Description() {
        return `${this.a.Description}[OR]${this.b.Description}`;
    }
}
class PermissionAnd extends Permission {
    constructor(a, b) {
        super();
        this.a = a;
        this.b = b;
    }
    get Open() {
        return this.a.Open && this.b.Open; // this.this.Open ==> false  this.权限字符串.Open
    }
    get Description() {
        return `${this.a.Description}[AND]${this.b.Description}`;
    }
}
// 通用Permission
export function makePermission(info) {
    const resourceMap = new Map();
    _.each(info.current_resource_infos, resource => {
        const { alias, http_method, } = resource;
        if (!resourceMap.has(alias)) {
            resourceMap.set(alias, new Set());
        }
        resourceMap.get(alias).add(http_method);
    });
    function hasPermission(resource, http_method) {
        // 特殊处理 有的后端没有对应的resource
        if (_.isEmpty(resource)) {
            return true;
        }
        if (!resourceMap.has(resource)) {
            return false;
        }
        if (http_method) {
            return resourceMap.get(resource).has(http_method);
        }
        return true;
    }
    function toPermission(resource, http_method) {
        return Permission.Of({
            resource,
            method: http_method,
            check: hasPermission,
        });
    }
    // trick 使用class简化编写
    class PermissionCollections {
        constructor() {
            // 公司用户上的数据报告
            this.CompanyRptUserStats = toPermission('/backoffice/company-rpt/company/user-stats', E_HttpMethod.GET);
            // 公司用户图像上的报告
            this.CompanyAccountRptChartId = toPermission('/backoffice/company-rpt/account/{accountId}/{chartId}', E_HttpMethod.GET);
            this.CompanyInfo = true;
            // 同步销售易
            this.CompanyXiaoshouyiSync = toPermission('/backoffice/company-xiaoshouyi/companies/{companyId}/sync', E_HttpMethod.POST);
            // 同步计费类型
            this.CompanyFixDataSync = toPermission('/backoffice/companies/{companyId}/charge-mode/compute', E_HttpMethod.POST);
            // 同步Salesforce
            this.CompanySalesforceSync = toPermission('/backoffice/salesforce-synchronize/{companyName}/all', E_HttpMethod.POST);
            // 批量分配权限
            this.CompanyPrivilegeAssignationBatch = toPermission('/backoffice/company-privilege/assignation/batch', E_HttpMethod.POST);
            // 编辑Privilege
            this.CompanyPrivilegeEdit = toPermission('/backoffice/company-privilege', E_HttpMethod.PUT);
            // EnableDisable Privilege
            this.CompanyPrivilegeDisable = toPermission('/backoffice/company-privilege-contract/{id}/disable', E_HttpMethod.PATCH);
            this.CompanyPrivilegeEnable = toPermission('/backoffice/company-privilege-contract/{id}/enable', E_HttpMethod.PATCH);
            // 添加Privilege
            this.CompanyPrivilegeAdd = toPermission('/backoffice/company-privilege', E_HttpMethod.POST);
            // 更新公司信息
            this.CompanyPrivilegeUpdate = toPermission('/backoffice/company-privilege', E_HttpMethod.PATCH);
            // 课程管理
            this.CompanyDetailCourseManager = toPermission('/backoffice/company-detail-course-manager');
            /**
             * 如果有这个权限,则可以访问产品列表、权限列表
             */
            this.CompanyPrivilegeList = toPermission(E_Company_Organization.CompanyPrivilegeList, E_HttpMethod.GET);
            // 公司默认设置
            this.CompanyDefaultPreference = toPermission(E_Company_Organization_Setting.CompanyDefaultPreference, E_HttpMethod.GET);
            /**
             * 决定是否可编辑
             */
            this.SecuritySettingSubmit = toPermission(E_Company_Organization_Setting.SecuritySettingSubmit, E_HttpMethod.PATCH);
            this.SecuritySettingIpDomainSubmit = toPermission(E_Company_Organization_Setting.SecuritySettingIpDomainSubmit, E_HttpMethod.PATCH);
            /**
             * 决定显示不显示
             */
            this.GetSecuritySetting = toPermission(E_Company_Organization_Setting.GetSecuritySetting, E_HttpMethod.GET);
            this.SettingsSubmit = toPermission(E_Company_Organization_Setting.SettingsSubmit, E_HttpMethod.PATCH);
            this.SsoSettingSubmit = toPermission(E_Company_Organization_Setting.SsoSettingSubmit, E_HttpMethod.PATCH);
            this.GeneralSettingSubmit = toPermission(E_Company_Organization_Setting.GeneralSettingSubmit, E_HttpMethod.PATCH);
            this.GetGrantSetting = toPermission(E_Company_Organization_Setting.GetGrantSetting, E_HttpMethod.GET);
            this.GetCompanySystemLimit = toPermission(E_Company_Organization_Setting.CompanySystemLimit, E_HttpMethod.GET);
            // GetCompanySystemLimit = toPermission(E_Company_Organization_Setting.GetGrantSetting, E_HttpMethod.GET )
            this.PatchCompanySystemLimit = toPermission(E_Company_Organization_Setting.PatchCompanySystemLimit, E_HttpMethod.PATCH);
            this.PostCompaniesUnbindUserCarsi = toPermission(E_Company_Organization_Setting.PostCompaniesUnbindUserCarsi, E_HttpMethod.POST);
            this.PatchCompaniesSystemJwtSsoDisplay = toPermission(E_Company_Organization_Setting.PatchCompaniesSystemJwtSsoDisplay, E_HttpMethod.PATCH);
            this.CompanyOrganizationDetailInfo = toPermission(E_Company_Organization.CompanyOrganizationDetailInfo, E_HttpMethod.GET);
            // 查看公司报告
            this.CompanyReport = this.CompanyRptUserStats;
            this.HistoryList = toPermission(E_Company_Organization.CompanyHistoryList, E_HttpMethod.GET);
            this.GetCompanyDataAnalysis = toPermission(EP_DataAnalysis.GetCompanyDataAnalysis, E_HttpMethod.POST);
            this.GetCompanyDataAnalysisDetail = toPermission(EP_DataAnalysis.GetCompanyDataAnalysisDetail, E_HttpMethod.POST);
            this.GetCompanyDataAnalysisWsDashboard = toPermission(EP_DataAnalysis.GetCompanyDataAnalysisWsDashboard, E_HttpMethod.POST);
            this.CompanySubscriptions = toPermission(E_Company_Organization_Setting.CompanySubscriptions, E_HttpMethod.GET);
            this.CompanySubscriptionsSetting = toPermission(E_Company_Organization_Setting.CompanySubscriptionsSetting, E_HttpMethod.POST);
            // 公司列表
            this.CompanyList = toPermission('/backoffice/companies/pagination', E_HttpMethod.POST);
            // 公司创建
            this.CompanyCreate = toPermission('/backoffice/companies', E_HttpMethod.POST);
            // 公司修改基本信息
            this.CompanyModifyInfo = toPermission('/backoffice/companies', E_HttpMethod.POST);
            // 公司批量编辑
            this.CompanyBatchEdit = toPermission('/backoffice/companies/paid-type/batch', E_HttpMethod.POST);
            // 批量添加
            this.CooperativeCompaniesBatchAdd = toPermission('/backoffice/cooperative-companies/batch-add', E_HttpMethod.POST);
            // 批量修改
            this.CooperativeCompaniesBatchEdit = toPermission('/backoffice/cooperative-companies/batch-edit', E_HttpMethod.POST);
            // 获取某个合作推广公司
            this.CooperativeCompaniesGet = toPermission('/backoffice/cooperative-companies/{cooperativeCompanyId}', E_HttpMethod.GET);
            // 编辑某个合作推广公司
            this.CooperativeCompaniesEdit = toPermission('/backoffice/cooperative-companies/{cooperativeCompanyId}', E_HttpMethod.POST);
            // 获取合作推广列表
            this.CooperativeCompaniesList = toPermission('/backoffice/cooperative-companies', E_HttpMethod.GET);
            // 公司insights
            this.CompanyInsights = toPermission('/backoffice/customer-ai-report/{companyId}', E_HttpMethod.GET);
            // #endregion
            // 账号批量编辑
            this.AccountBatchEdit = toPermission('/backoffice/accounts/batch/edit', E_HttpMethod.PATCH);
            // 账号编辑
            this.AccountEdit = toPermission('/backoffice/accounts/edit', E_HttpMethod.PATCH);
            // 添加账号权限
            this.AccountAddPrivilege = toPermission('/backoffice/account-privilege', E_HttpMethod.POST);
            // 删除账号权限
            this.AccountDeletePrivilege = toPermission('/backoffice/account-privilege/{accountId}/{companyPrivilegeId}', E_HttpMethod.DELETE);
            this.AccountIndividualClose = toPermission('/backoffice/tenant-users/individual/{tenantUserId}/{enabled}', E_HttpMethod.PUT);
            this.AccountList = toPermission(E_Account.AccountsList, E_HttpMethod.POST);
            this.AccountDetailEditUserRole = toPermission(E_Account.AccountDetailEditUserRole, E_HttpMethod.POST);
            this.AccountSetting = toPermission(E_Account.AccountSetting, E_HttpMethod.PUT);
            this.AccountSecuritySetting = toPermission(E_Account.AccountSecuritySetting, E_HttpMethod.POST);
            /**
             * 用户详情导出：必须具备详情权限，才可访问导出功能
             */
            this.AccountReport = toPermission(E_Account.AccountInfoReport, E_HttpMethod.GET);
            /** 用户产品 */
            this.AccountProduct = toPermission(E_Account.AccountProduct, E_HttpMethod.GET);
            /** 用户产品 Credits */
            this.AccountCredits = toPermission(E_Account.AccountCredits, E_HttpMethod.GET);
            this.AccountCreditsConsumptionDetailDownload = toPermission(E_Account.AccountCreditsConsumptionDetailDownload, E_HttpMethod.GET);
            this.AccountCreditsDailyCreditLimitEdit = toPermission(E_Account.AccountCreditsDailyCreditLimitEdit, E_HttpMethod.PUT);
            this.AccountPrivilegeExcludeFeatureUpdate = toPermission(E_Account.AccountPrivilegeExcludeFeatureUpdate, E_HttpMethod.PUT);
            // 创建试用（用户列表顶部按钮）
            this.AccountCreateTrial = toPermission('/backoffice/tenant-user-privileges/add-trial', E_HttpMethod.POST);
            // 添加试用，同一公司单个或多个用户添加试用
            this.AccountAddTrial = toPermission('/backoffice/tenant-user-privileges/add-trial-tenant', E_HttpMethod.POST);
            // 导出公司的使用记录
            this.ExportCompaniesUsageData = toPermission('/backoffice/behavior-export/companies', E_HttpMethod.POST);
            // 导出用户的使用记录
            this.ExportUsersUsageData = toPermission('/backoffice/behavior-export/users', E_HttpMethod.POST);
            // 导出检索用户列表
            this.ExportUsers = toPermission('/backoffice/behavior-export/export-users', E_HttpMethod.POST);
            // 导出公司的行为报告
            this.ExportCompanyUsageData = toPermission('/backoffice/behavior-export/company', E_HttpMethod.GET);
            // 重发激活邮件
            this.AccountResendEmail = toPermission('/backoffice/accounts/send/email/{accountId}', E_HttpMethod.GET);
            // 修改密码
            this.AccountUpdatePassword = toPermission('/backoffice/accounts/{accountId}/password', E_HttpMethod.PATCH);
            // 激活
            this.AccountActivation = toPermission('/backoffice/accounts/activation', E_HttpMethod.PATCH);
            // 伪激活
            this.AccountFakeActivation = toPermission('/backoffice/tenant-users/batch/fake-active', E_HttpMethod.POST);
            // 账号修改
            this.AccountModifyInfo = toPermission('/backoffice/accounts', E_HttpMethod.POST);
            // 账号block
            this.AccountBlock = toPermission('/backoffice/accounts/block', E_HttpMethod.PATCH);
            // 账号unblock
            this.AccountUnBlock = toPermission('/backoffice/accounts/unblock', E_HttpMethod.PATCH);
            // 账号移除
            this.AccountRemove = toPermission('/backoffice/tenant-users/batch/disable', E_HttpMethod.POST);
            // 解锁账号
            this.AccountUnlock = toPermission('/backoffice/accounts/{accountId}/unlock', E_HttpMethod.PATCH);
            // 账号详情
            this.AccountsDetail = toPermission(E_Account.AccountsDetail, E_HttpMethod.GET);
            // 帐号默认设置
            this.AccountDefaultPreference = toPermission(E_Account.AccountDefaultPreference, E_HttpMethod.GET);
            // 查看系统限制
            this.AccountSystemLimit = toPermission(E_Account.AccountSystemLimit, E_HttpMethod.GET);
            // 账号订阅邮件查看
            this.AccountSubscriptions = toPermission(E_Account.AccountSubscriptions, E_HttpMethod.GET);
            // 账号邮件订阅设置
            this.AccountSubscriptionsSetting = toPermission(E_Account.AccountSubscriptionsSetting, E_HttpMethod.POST);
            // 账号数据分析
            this.AccountDataAnalysis = toPermission(E_Account.AccountDataAnalysis, E_HttpMethod.POST);
            /** 用户 - 设置 - 系统限制 */
            this.patchAccountsSystemLimit = toPermission('/backoffice/accounts/system/limit/edit', E_HttpMethod.PATCH);
            this.postAccountsCasBind = toPermission('/backoffice/account-binding', E_HttpMethod.POST);
            // SuperSet
            this.SuperSet = toPermission('/backoffice/superset');
            // 黑爬虫相关
            this.BlackQuery = toPermission('/backoffice/patsnap-operation/export-black-query-management');
            this.DashboardInfo = toPermission('/backoffice/dashboard-info', E_HttpMethod.GET);
            this.DashboardInfoId = toPermission('/backoffice/dashboard-info/{dashboard_id}', E_HttpMethod.GET);
            // #endregion
            /** ***************** 故障排除 ********************/
            // #region 通知中心
            this.PostNotificationUserMessageList = toPermission(EP_Notifications.PostNotificationUserMessageList, E_HttpMethod.POST);
            this.PostNotificationScenesList = toPermission(EP_Notifications.PostNotificationScenesList, E_HttpMethod.POST);
            this.PostNotificationScenes = toPermission(EP_Notifications.PostNotificationScenes, E_HttpMethod.POST);
            // #region 邮件发送/回应/不可达邮件
            this.MailConfigList = toPermission(E_Troubleshooting.MailConfigList, E_HttpMethod.GET);
            this.MailSendList = toPermission(E_Troubleshooting.MailSendList, E_HttpMethod.GET);
            this.MailRecepitList = toPermission(E_Troubleshooting.MailRecepitList, E_HttpMethod.GET);
            this.MailUnreachableGetList = toPermission(E_Troubleshooting.MailUnreachableGetList, E_HttpMethod.GET);
            // #endregion
            // #region 短信发送
            this.MessageSend = toPermission(E_Troubleshooting.MessageSend, E_HttpMethod.GET);
            // #endregion
            // #region  会话
            // 公司-会话列表 有这个就可以访问
            this.CompanySessionGetList = toPermission(E_SessionManagement.CompanySessionGetList, E_HttpMethod.GET);
            this.AccountSessionGetList = toPermission(E_SessionManagement.AccountSessionGetList, E_HttpMethod.GET);
            // #endregion
            // 会话踢出信息
            this.SessionKickoutauditrecordsGetList = toPermission(E_Troubleshooting.SessionKickoutauditrecordsGetList, E_HttpMethod.GET);
            // 历史信息
            this.HistoryGetList = toPermission(E_Troubleshooting.HistoryGetList, E_HttpMethod.GET);
            // #endregion
            /** ***************** 运营工具 ********************/
            // #region Patsnap Lab
            this.AppManagement = toPermission(E_PatsnapLab.AppManagement);
            this.AppAnalysis = toPermission(E_PatsnapLab.AppManagement);
            this.SuggestionFeedback = toPermission(E_PatsnapLab.AppManagement);
            // #endregion
            // #region Ab Test
            this.AbTestManagement = toPermission(E_PatsnapLab.AbTestManagement);
            this.PromptManagement = toPermission(E_OperationTool.PromptManagement);
            this.EmailTemplateManagement = toPermission(E_OperationTool.EmailTemplateManagement);
            this.OrganizationManagement = toPermission(E_OperationTool.OrganizationManagement);
            // #region Ab Test
            // 任务中心
            this.TaskCenter = toPermission(E_Workspace.TaskCenter);
            // 数据迁移
            this.DataMigration = toPermission(E_Workspace.DataMigration);
            // 数据分析
            this.DataAnalysis = toPermission(E_Workspace.DataAnalysis);
            // 分离数据管理
            this.SeparateDataManagement = toPermission(E_Workspace.SeparateDataManagement);
            // 分离数据统计
            this.SeparateDataStatistics = toPermission(E_Workspace.SeparateDataStatistics);
            // #endregion
            // #region 导航库
            this.NavigationLibraryAudit = toPermission(E_NavigationLibrary.NavigationLibraryAudit);
            this.AgencyList = toPermission(E_NavigationLibrary.AgencyList);
            this.NavigationLibraryOperation = toPermission(E_NavigationLibrary.NavigationLibraryOperation);
            // #endregion
            // #region 推荐管理
            this.HomePageConfiguration = toPermission(E_RecommendationManagement.HomePageConfiguration);
            this.EditorsPickManagement = toPermission(E_RecommendationManagement.EditorsPickManagement);
            // #endregion
            // #region OpenAPI
            // 菜单分类
            this.MenuClassification = toPermission(E_OpenApi.MenuClassification);
            // openApi 维护
            this.ApiConfig = toPermission(E_OpenApi.ApiConfig);
            // openApi 白名单
            this.ApiWhitelist = toPermission(E_OpenApi.ApiWhitelist);
            // 产品套餐维护
            this.ProductPackageManagement = toPermission(E_OpenApi.ProductPackageManagement);
            // 套餐key维护
            this.PackageKey = toPermission(E_OpenApi.PackageKey);
            // 月度消费账单
            this.MonthlyBill = toPermission(E_OpenApi.MonthlyBill);
            // 套餐使用明细
            this.PackageUsage = toPermission(E_OpenApi.PackageUsage);
            // 客户使用排行
            this.CustomerUsageRanking = toPermission(E_OpenApi.CustomerUsageRanking);
            // 套餐使用排行
            this.PackeageUsageRanking = toPermission(E_OpenApi.PackeageUsageRanking);
            // 接口使用排行
            this.APIUsageRanking = toPermission(E_OpenApi.APIUsageRanking);
            // 门户内容维护--首页
            this.ContentConfigurableIndex = toPermission(E_OpenApi.ContentConfigurableIndex);
            // 门户内容维护--解决方案分组
            this.ContentConfigurableSolutionGroup = toPermission(E_OpenApi.ContentConfigurableSolutionGroup);
            // 门户内容维护--解决方案
            this.ContentConfigurableSolution = toPermission(E_OpenApi.ContentConfigurableSolution);
            // 门户内容维护--本地数据包
            this.ContentConfigurableDataPackage = toPermission(E_OpenApi.ContentConfigurableDataPackage);
            // #endregion
            // #region 开放平台
            // Api 使用分析
            this.ApiAnalysis = toPermission(E_OpenPlatform.ApiAnalysis, E_HttpMethod.GET);
            // 产品客户端
            this.ProductClient = toPermission(E_OpenPlatform.ProductClient, E_HttpMethod.GET);
            // 产品套餐:动作资源'backoffice:bundles'
            this.ProductBundle = toPermission(E_OpenPlatform.ProductBundle, E_HttpMethod.PUT);
            // 产品客户端套餐
            this.ProductClientBundle = toPermission(E_OpenPlatform.ProductClientBundle, E_HttpMethod.GET);
            // 网关管理:动作资源 backoffice:gateway:pagination
            this.GatewayManagement = toPermission(E_OpenPlatform.GatewayManagement, E_HttpMethod.GET);
            // #region 自注册
            this.ApplyTrialList = toPermission(E_ApplyTrial.ApplyTrialList, E_HttpMethod.GET);
            this.ApplyTrialPutNoticeLimitation = toPermission(E_ApplyTrial.ApplyTrialPutNoticeLimitation, E_HttpMethod.PUT);
            this.ApplyTrialputIpLimitation = toPermission(E_ApplyTrial.ApplyTrialputIpLimitation, E_HttpMethod.PUT);
            this.ApplyTrialAnalysis = toPermission(E_ApplyTrial.ApplyTrialAnalysis, E_HttpMethod.GET);
            // #endregion
            // #region 产品资源位管理
            this.ProductLine = toPermission(EP_ProductResourceSpaceManagement.GetProductLine, E_HttpMethod.GET);
            this.GetResourceSpace = toPermission(EP_ProductResourceSpaceManagement.GetResourceSpace, E_HttpMethod.GET);
            this.GetResourceSpaceContent = toPermission(EP_ProductResourceSpaceManagement.GetResourceSpaceContent, E_HttpMethod.GET);
            // 获取PQL规则管理
            this.PqlRuleManagementList = toPermission(EP_PqlRuleManagement.GetPqlRuleManagementList, E_HttpMethod.GET);
            this.PqLRuleDataAnalysisList = toPermission(EP_PqlRuleManagement.PostPqLRuleDataAnalysisList, E_HttpMethod.POST);
            // #endregion
            // #region 数据保护
            // 限制管理
            this.ExportManagement = toPermission(E_DataProtection.ExportManagement);
            // 限制列表
            this.RestrictionList = toPermission(E_DataProtection.RestrictionList);
            this.RestrictionListOperationDisable = toPermission(E_DataProtection.RestrictionListOperationDisable);
            this.RestrictionListOperationRelieve = toPermission(E_DataProtection.RestrictionListOperationRelieve);
            this.RestrictionListOperationDetail = toPermission(E_DataProtection.RestrictionListOperationDetail);
            // 白名单
            this.WhiteList = toPermission(E_DataProtection.WhiteList);
            // 公司树
            this.CompanyTree = toPermission(E_DataProtection.CompanyTree);
            // 用户限制查询
            this.UserRestrictedQuery = toPermission(E_DataProtection.UserRestrictedQuery);
            // get UserRestrictedQuery () {
            //     return Permission.And(
            //         toPermission(E_DataProtection.RestrictionList),
            //         this.CompanyAccountRptChartId,
            //     )
            // }
            this.CarsiSuspectSellUserList = toPermission(E_IllegalManagement.CarsiSuspectSellUserList, E_HttpMethod.GET);
            this.CarsiSuspectSellIPList = toPermission(E_IllegalManagement.CarsiSuspectSellIPList, E_HttpMethod.GET);
            this.CarsiSuspectSellTenantList = toPermission(E_IllegalManagement.CarsiSuspectSellTenantList, E_HttpMethod.GET);
            // #endregion
            /** ***************** 开发工具 ********************/
            // #region  产品
            // 获取角色列表
            this.ProductRolesGetList = toPermission(E_ProductManager.ProductRolesGetList, E_HttpMethod.GET);
            // 产品-角色限制
            this.ResourcesRoleLimitationGetList = toPermission(E_ProductManager.ResourcesRoleLimitationGetList, E_HttpMethod.GET);
            // 产品-资源( 动作资源 & 页面资源 )
            this.ResourcesGetList = toPermission(E_ProductManager.ResourcesGetList, E_HttpMethod.GET);
            // 产品-角色资源导入
            this.RoleResourceImport = toPermission(E_ProductManager.RoleResourceImport, E_HttpMethod.POST);
            // 三个状态：产品-产品客户端true 运营工具-开放平台-产品客户端false 运营工具-开放平台-产品客户端套餐(true && false)
            this.ProductClientsGetList = toPermission(E_ProductManager.ProductClientsGetList, E_HttpMethod.GET);
            // 产品客户端 - 产品管理
            this.ProductGet = toPermission(E_ProductManager.ProductGet, E_HttpMethod.GET);
            this.ProductPost = toPermission(E_ProductManager.ProductPost, E_HttpMethod.POST);
            this.ProductDelete = toPermission(E_ProductManager.ProductDelete, E_HttpMethod.DELETE);
            // #endregion
            // #region 字典管理
            this.SystemcodeGetList = toPermission(E_DeveloperTool.SystemcodeGetList, E_HttpMethod.GET);
            // #endregion
            // #region 系统
            // 系统配置  进入页面后此权限必须，但有些用户不需要这个权限，所以这里要改成POST 方法
            this.SystemConfiguration = toPermission(E_SystemManager.SystemConfiguration, E_HttpMethod.POST);
            // 搜索引擎管理(二级菜单):公司、用户、历史
            this.CompanyIndexGetList = toPermission(E_SearchEngineManagement.CompanyIndexGetList, E_HttpMethod.GET);
            this.AccountIndexGetList = toPermission(E_SearchEngineManagement.AccountIndexGetList, E_HttpMethod.GET);
            // 缓存管理
            this.CacheManagement = toPermission(E_SystemManager.CacheManagement, E_HttpMethod.GET);
            // 同步redis
            this.RedisPublishmentResourceUpdatedTopic = toPermission(E_SynchronizationRedis.RedisPublishmentResourceUpdatedTopic, E_HttpMethod.POST);
            this.RedisSynchronizationSoiResource = toPermission(E_SynchronizationRedis.RedisSynchronizationSoiResource, E_HttpMethod.POST);
            // SAML
            this.SamlConfigGetList = toPermission(E_SystemManager.SamlConfigGetList, E_HttpMethod.GET);
            // SQL
            this.SqlGetList = toPermission(E_SystemManager.SqlGetList, E_HttpMethod.GET);
            // core 工具
            this.AccountInformationQuery = toPermission(E_CoreUtility.AccountInformationQuery);
            this.CoreUtilityCacheManagement = toPermission(E_CoreUtility.CoreUtilityCacheManagement);
            this.EmailAlertTest = toPermission(E_CoreUtility.EmailAlertTest);
            this.EmailAlertDebugger = toPermission(E_CoreUtility.EmailAlertDebugger);
            this.GatewayPermissions = toPermission(E_CoreUtility.GatewayPermissions);
            this.Limitation = toPermission(E_CoreUtility.Limitation);
            this.postman = toPermission(E_CoreUtility.postman);
            this.CacheManagementTFFI = toPermission(E_CoreUtility.CacheManagementTFFI);
            this.ConfigList = toPermission(E_CoreUtility.ConfigList);
            this.EmailConcurrencyTest = toPermission(E_CoreUtility.EmailConcurrencyTest);
            // #endregion
            // #region PermissionResourceEdit
            this.ProductResourceList = toPermission(PermissionResourceEdit.ProductResourceList, E_HttpMethod.GET);
            this.ResourceList = toPermission(PermissionResourceEdit.ResourceList, E_HttpMethod.GET);
            this.ResourceCreate = toPermission(PermissionResourceEdit.ResourceCreate, E_HttpMethod.POST);
            this.ResourceEdit = toPermission(PermissionResourceEdit.ResourceEdit, E_HttpMethod.PUT);
            this.ServiceItem = toPermission(PermissionResourceEdit.ServiceItem, E_HttpMethod.GET);
            this.ServiceList = toPermission(PermissionResourceEdit.ServiceList, E_HttpMethod.GET);
            this.ServiceCreate = toPermission(PermissionResourceEdit.ServiceCreate, E_HttpMethod.POST);
            this.ServiceEdit = toPermission(PermissionResourceEdit.ServiceEdit, E_HttpMethod.PUT);
            this.ServiceAttributesEdit = toPermission(PermissionResourceEdit.ServiceAttributesEdit, E_HttpMethod.PUT);
            this.ServiceUnitPriceEdit = toPermission(PermissionResourceEdit.ServiceUnitPriceEdit, E_HttpMethod.PUT);
            this.ServiceClone = toPermission(PermissionResourceEdit.ServiceClone, E_HttpMethod.POST);
            this.ServiceResourceLimitationsList = toPermission(PermissionResourceEdit.ServiceResourceLimitationsList, E_HttpMethod.GET);
            this.ServiceResourceLimitationsCreate = toPermission(PermissionResourceEdit.ServiceResourceLimitationsCreate, E_HttpMethod.POST);
            this.ServiceResourceLimitationsEdit = toPermission(PermissionResourceEdit.ServiceResourceLimitationsEdit, E_HttpMethod.PUT);
            this.ServiceResourceLimitationsDelete = toPermission(PermissionResourceEdit.ServiceResourceLimitationsDelete, E_HttpMethod.PUT);
            this.CapacityList = toPermission(PermissionResourceEdit.CapacityList, E_HttpMethod.GET);
            this.CapacityCreate = toPermission(PermissionResourceEdit.CapacityCreate, E_HttpMethod.POST);
            this.CapacityEdit = toPermission(PermissionResourceEdit.CapacityEdit, E_HttpMethod.PUT);
            // #endregion
            /**
             * 套餐
             */
            this.PackagesList = toPermission(PermissionResourceEdit.PackagesList, E_HttpMethod.GET);
            this.PackagesCreate = toPermission(PermissionResourceEdit.PackagesCreate, E_HttpMethod.POST);
            this.PackagesEdit = toPermission(PermissionResourceEdit.PackagesEdit, E_HttpMethod.PATCH);
            // #region Capacity详情
            this.CapacityDetailCompany = toPermission(CapacityDetail.CapacityDetailCompany, E_HttpMethod.GET);
            this.CapacityDetailAccount = toPermission(CapacityDetail.CapacityDetailAccount, E_HttpMethod.GET);
            // #endregion
            // #region Order相关
            this.OrdersList = toPermission(CompanyOrder.OrdersList, E_HttpMethod.GET);
            this.OrderDetail = toPermission(CompanyOrder.OrderDetail, E_HttpMethod.GET);
            this.OrderAdd = toPermission(CompanyOrder.OrderAdd, E_HttpMethod.POST);
            this.OrderEdit = toPermission(CompanyOrder.OrderEdit, E_HttpMethod.PUT);
            this.OrderEnable = toPermission(CompanyOrder.OrderEnable, E_HttpMethod.PATCH);
            this.OrderDisable = toPermission(CompanyOrder.OrderDisable, E_HttpMethod.PATCH);
            this.CompanyPrivilegeContractDelete = toPermission(CompanyOrder.CompanyPrivilegeContractDelete, E_HttpMethod.PATCH);
            this.CompanyCapacityContractDelete = toPermission(CompanyOrder.CompanyCapacityContractDelete, E_HttpMethod.PATCH);
            this.CompanyCapacityContractAllDelete = toPermission(CompanyOrder.CompanyCapacityContractAllDelete, E_HttpMethod.PATCH);
            this.OrderContractExisted = toPermission(CompanyOrder.OrderContractExisted, E_HttpMethod.GET);
            this.OrderEditCheck = toPermission(CompanyOrder.OrderEditCheck, E_HttpMethod.POST);
            this.CompanyOrderOpenapiEmbed = toPermission(CompanyOrder.CompanyOrderOpenapiEmbed);
            // #endregion
            // #region Credits相关
            this.CompanyCreditsRecharge = toPermission(CompanyCredits.CompanyCreditsRecharge, E_HttpMethod.POST);
            this.CompanyCreditsRechargeEdit = toPermission(CompanyCredits.CompanyCreditsRechargeEdit, E_HttpMethod.PUT);
            this.CompanyCreditsPrivilegeAdd = toPermission(CompanyCredits.CompanyCreditsPrivilegeAdd, E_HttpMethod.POST);
            this.CompanyCreditsPrivilegeAssign = toPermission(CompanyCredits.CompanyCreditsPrivilegeAssign, E_HttpMethod.POST);
            this.CompanyCreditsPrivilegeFeatureUpdate = toPermission(CompanyCredits.CompanyCreditsPrivilegeFeatureUpdate, E_HttpMethod.PUT);
            this.CompanyCreditsConsumptionDetailDownload = toPermission(CompanyCredits.CompanyCreditsConsumptionDetailDownload, E_HttpMethod.GET);
            this.CompanyCreditsConfigEdit = toPermission(CompanyCredits.CompanyCreditsConfigEdit, E_HttpMethod.PUT);
            this.CompanyCreditsGroupList = toPermission(CompanyCredits.CompanyCreditsGroupList, E_HttpMethod.GET);
            this.CompanyCreditsGroupCreate = toPermission(CompanyCredits.CompanyCreditsGroupList, E_HttpMethod.POST);
            this.CompanyCreditsGroupEdit = toPermission(CompanyCredits.CompanyCreditsGroupDetail, E_HttpMethod.PUT);
            this.CompanyCreditsGroupDelete = toPermission(CompanyCredits.CompanyCreditsGroupDetail, E_HttpMethod.DELETE);
            this.CompanyCreditsGroupAllocate = toPermission(CompanyCredits.CompanyCreditsGroupAllocations, E_HttpMethod.POST);
            this.CompanyCreditsGroupRelease = toPermission(CompanyCredits.CompanyCreditsGroupAllocationRelease, E_HttpMethod.POST);
            // #endregion
            // #region 数据分析
            // 用户分析
            this.UserAnalysis = toPermission(E_DataAnalysis.UserAnalysis);
            this.CustomerBoardCharts = toPermission(EP_Behavior.ActiveBoard, E_HttpMethod.POST);
            this.GlobalViewList = toPermission(EP_GlobalView.GlobalViewList, E_HttpMethod.POST);
            // #region Admin
            this.AdminPatsnapAccountList = toPermission(EP_Admin.AdminPatsnapAccountList, E_HttpMethod.GET);
            this.AdminRoleList = toPermission(EP_Admin.AdminRoleList, E_HttpMethod.GET);
            this.AdminHistory = toPermission(EP_Admin.AdminHistory, E_HttpMethod.GET);
            this.AdminAudit = toPermission(EP_Admin.AdminAuditList, E_HttpMethod.GET);
            this.AdminCorsWhitelist = toPermission(EP_Admin.AdminCorsWhitelist, E_HttpMethod.GET);
            this.AdminAddAccountPatsnap = toPermission(EP_Admin.AdminAddPatsnapAccount, E_HttpMethod.POST);
            this.ReleasePlanList = toPermission(EP_ReleasePlan.ReleasePlanList, E_HttpMethod.GET);
            this.ReleasePlanDetail = toPermission(EP_ReleasePlan.ReleasePlanDetail, E_HttpMethod.GET);
            this.ReleasePlanAdd = toPermission(EP_ReleasePlan.ReleasePlanAdd, E_HttpMethod.POST);
            this.ReleasePlanUpdate = toPermission(EP_ReleasePlan.ReleasePlanUpdate, E_HttpMethod.PUT);
            this.ReleasePlanSwitchEnabled = toPermission(EP_ReleasePlan.RelasePlanSwitchEnabled, E_HttpMethod.PATCH);
            // #region 活动推广链接
            this.ActivityPromotionList = toPermission(EP_ActivityPromotion.GetActivityPromotionList, E_HttpMethod.GET);
            this.ActivityPromotionProduct = toPermission(EP_ActivityPromotion.GetActivityPromotionProduct, E_HttpMethod.GET);
            this.ActivityPromotionEnabled = toPermission(EP_ActivityPromotion.PatchActivityPromotionEnabled, E_HttpMethod.PATCH);
            /**
             * 活动推广新增
             */
            this.ActivityPromotionItemAdd = toPermission(EP_ActivityPromotion.PostActivityPromotionItem, E_HttpMethod.POST);
            this.ActivityPromotionItemEdit = toPermission(EP_ActivityPromotion.PutActivityPromotionItem, E_HttpMethod.PUT);
            this.ActivityPromotionCampaignsSync = toPermission(EP_ActivityPromotion.PostActivityPromotionCampaignsSync, E_HttpMethod.POST);
            // #endregion
            // #region  通用工具 运营数据更新
            this.PostBatchTrial = toPermission(E_CoreUtility.postBatchTrial, E_HttpMethod.POST);
            this.PostAccountJobRoleComplement = toPermission(E_CoreUtility.postAccountJobRoleComplement, E_HttpMethod.POST);
        }
        get CompanyInfoProduct() {
            return Permission.And(this.CompanyPrivilegeList, this.CompanyOrganizationDetailInfo);
        }
        get CompanySetting() {
            return Permission.Or(this.GetSecuritySetting, // 这里返回的是一个 new PermissionSingle(option)
            this.SettingsSubmit, // 这里返回的是一个 new PermissionSingle(option)
            this.GeneralSettingSubmit, this.SsoSettingSubmit, this.CompanyOrganizationDetailInfo, this.GetCompanySystemLimit);
        }
        get CompanyProductAnyEdit() {
            // return false
            return Permission.Or(this.CompanyPrivilegeAssignationBatch, this.CompanyPrivilegeEdit, this.CompanyPrivilegeDisable, this.CompanyPrivilegeEnable, this.CompanyPrivilegeAdd, this.CompanyPrivilegeUpdate);
        }
        get CompanyInfoReport() {
            return Permission.And(this.CompanyReport, this.CompanyOrganizationDetailInfo);
        }
        // 查看公司-组织-历史  账号历史
        get CompanyHistoryList() {
            return Permission.And(this.HistoryList, this.CompanyOrganizationDetailInfo);
        }
        /**
         * 公司设置
         */
        get CompanyOrganizationAccountList() {
            return Permission.And(this.CompanyOrganizationDetailInfo, this.AccountList);
        }
        /**
         * 数据分析
         */
        get CompanyDataAnalysis() {
            return Permission.And(this.GetCompanyDataAnalysis, this.GetCompanyDataAnalysisDetail, this.GetCompanyDataAnalysisWsDashboard);
        }
        /**
         * 公司模块
         */
        get Company() {
            return Permission.Or(this.CompanyList, this.CooperativeCompanies);
        }
        // #region 合作推广公司相关
        get CooperativeCompanies() {
            return this.CooperativeCompaniesList;
        }
        get AccountInfoReport() {
            return Permission.And(this.AccountReport, this.AccountsDetail);
        }
        /**
         * 账号tab
         */
        get Account() {
            return this.AccountList;
        }
        get AccountEditPrivilege() {
            return Permission.And(this.AccountAddPrivilege, this.AccountDeletePrivilege);
        }
        /**
        * 账号历史
        */
        get AccountHistoryList() {
            return Permission.And(this.HistoryList, this.AccountsDetail);
        }
        // #region dashboard
        get DashboardEditersPickManage() {
            return Permission.And(this.DashboardInfo, this.DashboardInfoId);
        }
        get Notifications() {
            return Permission.Or(this.PostNotificationUserMessageList, this.PostNotificationScenesList);
        }
        get Mail() {
            return Permission.Or(this.MailConfigList, this.MailSendList, this.MailRecepitList, this.MailUnreachableGetList);
        }
        get SessionManagement() {
            return Permission.Or(this.CompanySessionGetList, this.AccountSessionGetList);
        }
        // #region 故障排除
        get Troubleshooting() {
            return Permission.Or(this.Mail, this.MessageSend, this.SessionManagement, this.SessionKickoutauditrecordsGetList, this.HistoryGetList, this.PostNotificationUserMessageList, this.PostNotificationScenesList);
        }
        get PatsnapLab() {
            return Permission.Or(this.AppManagement, this.AppAnalysis, this.SuggestionFeedback);
        }
        // 数据分离
        get SeparateData() {
            return Permission.Or(this.SeparateDataManagement, this.SeparateDataStatistics);
        }
        // 工作空间
        get workspace() {
            return Permission.Or(this.TaskCenter, this.DataMigration, this.DataAnalysis, this.SeparateData);
        }
        get NavigationLibrary() {
            return Permission.Or(this.NavigationLibraryAudit, this.AgencyList, this.NavigationLibraryOperation);
        }
        get RecommendationManagement() {
            return Permission.Or(this.HomePageConfiguration, this.EditorsPickManagement);
        }
        // Api 使用分析
        get Analysis() {
            return Permission.Or(this.MonthlyBill, this.PackageUsage, this.CustomerUsageRanking, this.PackeageUsageRanking, this.APIUsageRanking);
        }
        // 门户内容维护
        get ContentConfigurable() {
            return Permission.Or(this.ContentConfigurableIndex, this.ContentConfigurableSolutionGroup, this.ContentConfigurableSolution, this.ContentConfigurableDataPackage);
        }
        // 显示openApi
        get OpenApi() {
            return Permission.Or(this.MenuClassification, this.ApiConfig, this.ApiWhitelist, this.ProductPackageManagement, this.Analysis, this.ContentConfigurable);
        }
        // 开放平台
        get OpenPlatform() {
            return Permission.Or(this.ApiAnalysis, this.ProductClient, this.ProductBundle, this.ProductClientBundle, this.GatewayManagement);
        }
        get ApplyTrial() {
            return Permission.Or(this.ApplyTrialList, this.ApplyTrialAnalysis);
        }
        get ProductResourceSpaceManagement() {
            return Permission.And(this.ProductLine, this.GetResourceSpace, this.GetResourceSpaceContent);
        }
        get PqlRuleManagement() {
            return Permission.And(this.ProductLine, this.PqlRuleManagementList, this.PqLRuleDataAnalysisList);
        }
        // 运营中心 - 运营管理
        get OperationManagement() {
            return Permission.Or(this.PqlRuleManagement, this.ProductResourceSpaceManagement);
        }
        get OperationTool() {
            return Permission.Or(this.PatsnapLab, this.workspace, this.NavigationLibrary, this.RecommendationManagement, this.OpenApi, this.OpenPlatform, this.ApplyTrialList, this.ReleasePlan, this.AbTestManagement, this.SelfRegisterLink, this.ProductResourceSpaceManagement, this.PromptManagement, this.EmailTemplateManagement, this.OrganizationManagement);
        }
        get IllegalManagement() {
            return Permission.Or(this.CarsiSuspectSellUserList, this.CarsiSuspectSellIPList, this.CarsiSuspectSellTenantList);
        }
        // 数据保护
        get DataProtection() {
            return Permission.Or(this.ExportManagement, this.RestrictionList, this.WhiteList, this.UserRestrictedQuery, this.CompanyTree, this.IllegalManagement);
        }
        // 产品权限都有， 产品列表在其他有引用， 目前不想按照 产品列表接口去判断能否进入产品管理页
        get ProductClientManager() {
            return Permission.Or(this.ProductGet, this.ProductClientsGetList);
        }
        // 是否显示产品角色
        get ProductManager() {
            return Permission.Or(this.Service, this.ProductRolesGetList, this.ResourcesRoleLimitationGetList, this.ResourcesGetList, this.RoleResourceImport, this.ProductClientsGetList);
        }
        // HistoryIndexGetList = toPermission(E_SearchEngineManagement.HistoryIndexGetList, E_HttpMethod.GET)
        get SearchEngineManagement() {
            return Permission.Or(this.CompanyIndexGetList, this.AccountIndexGetList
            // this.HistoryIndexGetList
            );
        }
        get SynchronizationRedis() {
            return Permission.Or(this.RedisPublishmentResourceUpdatedTopic, this.RedisSynchronizationSoiResource);
        }
        get SystemManager() {
            return Permission.Or(this.SystemConfiguration, this.SearchEngineManagement, this.CacheManagement, this.SynchronizationRedis, this.SamlConfigGetList, this.SqlGetList);
        }
        get CoreUtility() {
            return Permission.Or(this.AccountInformationQuery, this.CoreUtilityCacheManagement, this.EmailAlertTest, this.EmailAlertDebugger, this.GatewayPermissions, this.Limitation, this.postman, this.CacheManagementTFFI, this.ConfigList, this.EmailConcurrencyTest);
        }
        // 开发工具
        get DeveloperTool() {
            return Permission.Or(this.ProductManager, this.SystemcodeGetList, this.SystemManager, this.BlackQuery, this.CoreUtility);
        }
        /**
         * 资源
         */
        get Resource() {
            return this.ResourceList;
        }
        /**
         * 微服务
         */
        get Service() {
            return this.ServiceList;
        }
        get ServiceAction() {
            return Permission.Or(this.ServiceResourceLimitationsCreate, this.ServiceEdit, this.ServiceList, this.ServiceClone);
        }
        /**
         * 容量
         */
        get Capacity() {
            return Permission.And(this.CapacityList);
        }
        get Packages() {
            return this.PackagesList;
        }
        get PackagesMenu() {
            return Permission.Or(this.Packages, this.Capacity, this.Resource);
        }
        get DataStatistics() {
            return Permission.Or(this.UserAnalysis);
        }
        // #endregion
        get Dashboard() {
            return Permission.Or(this.CustomerBoardCharts, this.GlobalViewList);
        }
        get AdminRoleShow() {
            return Permission.And(this.AdminRoleList, this.ProductResourceList);
        }
        // #endregion
        // #region 发版计划
        get ReleasePlan() {
            return this.ReleasePlanList;
        }
        get ActivityPromotionVisible() {
            return Permission.And(this.ActivityPromotionList, this.ActivityPromotionProduct, this.ActivityPromotionEnabled, this.ActivityPromotionItemAdd, this.ActivityPromotionItemEdit);
        }
        get OperationDataUpdate() {
            return Permission.Or(this.PostBatchTrial, this.PostAccountJobRoleComplement);
        }
        // #endregion
        get SelfRegisterLink() {
            return Permission.Or(this.ActivityPromotionVisible, this.ApplyTrial);
        }
    }
    return {
        permission: new PermissionCollections(),
    };
}
// 数据Permission
export function makeDataResource(data = []) {
    return {
        resource: data,
    };
}
